/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './EServices.css';
import pans from './panStyle.scss';
import _ from 'lodash';
import CustomizedMap from './CustomizedMap';
import GrayPanel from '../../components/GrayPanel';
import cx from 'classnames';
import fetch from '../../core/fetch';
import UserInfo from './UserInfo';
import { countAction } from '../../lib/utils'

class ServiceWMSWFS extends React.Component {

  state = {
    selectedParcels: [],
    isServiceSelected: false,
    optradio1: true,
    optradio2: false,
    showWFS: false,
    selectedService: false,
  }

  setParcels = (parcels, callback=null) => this.setState({ selectedParcels: parcels })

  changeRadio = e => this.setState({ optradio1: !this.state.optradio1, optradio2: !this.state.optradio2 })

  runService = () => this.setState({ isServiceSelected: true });

  render() {
    // layout classes
    const leftCol = 'col-sm-2';
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-6';
    const rightCol = 'col-sm-2';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };
    const formDict = {
      FirstName: {
        label: 'Imię',
      },
      LastName: {
        label: 'Nazwisko',
      },
      FullName: {
        label: 'Nazwa wnioskodawcy',
      },
      AddressCity: {
        label: 'Miejscowość',
      },
      AddressStreet: {
        label: 'Ulica',
      },
      AddressFlat: {
        label: 'Numer lokalu',
      },
      AddressNumber: {
        label: 'Numer budynku',
      },
      AddressZipCode: {
        label: 'Kod pocztowy',
      },
      Email: {
        label: 'Email',
      },
    };
    const district = _.find(this.props.districts, v => v.teryt == this.props.district );

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className="row" style={{ marginTop: '15px' }}>
            <h3 style={{ textAlign: 'center'}}>
              {this.props.serviceInfo.eservice.title}
            </h3>
            {!this.state.isServiceSelected && <GrayPanel title="Wybór typu uslugi: ">
              <div className="radio">
                <label>
                  <input onChange={e => this.changeRadio(e)} type="radio" value="wms" name="optradio1" checked={this.state.optradio1} />
                    WMS
                </label>
                <br />
                <label>
                  <input onChange={e => this.changeRadio(e)} type="radio" value="wfs" name="optradio2" checked={this.state.optradio2} />
                    WFS
                </label>
              </div>
            </GrayPanel>
            }
            {this.state.optradio1 && this.state.isServiceSelected && <GrayPanel title="Informacje o usłudze WMS">
              <div>
                <h3>Usługi danych przestrzennych INSPIRE</h3>
                <p>
                  Gmina udostępnia usługi INSPIRE (WMS i WFS) pod adresem:<br />
                  <a href={`http://mapa.inspire-hub.pl/ows/${district.prefix}`}>{`http://mapa.inspire-hub.pl/ows/${district.prefix}`}</a><br />
                  <a href={`http://mapa.inspire-hub.pl/ows/${district.prefix}?SERVICE=WMS&REQUEST=GetCapabilities`}>Dokument Capabilities</a> dla WMS (usługa przeglądania)<br />
                </p><br /><br />
                <b>Do poczytania:</b><br />
                <a href="http://mapa.inspire-hub.pl/static/WMS_InspireHUB.pdf">
                  Jak używać tych usług w QGIS i ArcGIS?
                </a>
              </div>
              </GrayPanel>}
              {this.state.optradio2 && this.state.showWFS && this.state.isServiceSelected && <GrayPanel title="Informacje o usłudze WFS">
              <div>
                <h3>Usługi danych przestrzennych INSPIRE</h3>
                <p>
                  Gmina udostępnia usługi INSPIRE (WMS i WFS) pod adresem:<br />
                  <a href={`http://mapa.inspire-hub.pl/ows/${district.prefix}`}>{`http://mapa.inspire-hub.pl/ows/${district.prefix}`}</a><br />
                  <a href={`http://mapa.inspire-hub.pl/ows/${district.prefix}?SERVICE=WFS&REQUEST=GetCapabilities`}>Dokument Capabilities</a> dla WFS (usługa pobierania)<br />
                </p><br /><br />
                <b>Do poczytania:</b><br />
                <a href="http://mapa.inspire-hub.pl/static/WMS_InspireHUB.pdf">
                  Jak używać tych usług w QGIS i ArcGIS?
                </a>
              </div>
              </GrayPanel>}
            {this.state.isServiceSelected &&
              this.state.optradio2 &&
              !this.state.showWFS &&
              this.props.serviceInfo.eservice.requiresUserInfo &&
              this.props.serviceInfo.user ? <UserInfo userInfo={this.props.serviceInfo.user} /> : null}
              {this.state.isServiceSelected &&
              this.state.optradio2 && <GrayPanel title="Cel">
                <div className={leftCol} />
                <div className={labelCol}>
                  <label htmlFor="typ" style={labelStyle}>Cel</label>
                </div>
                <div className={inputCol}>
                  <input type="text" className="form-control" />
                </div>
                <div className={rightCol} />
              </GrayPanel>}
            {this.props.serviceInfo.eservice.mapConfig &&
              <GrayPanel title="Wybierz działki">
                <CustomizedMap
                  setParcels={this.setParcels}
                  selectedParcels={this.state.selectedParcels}
                  obreby={this.props.serviceInfo.precints}
                  district={this.props.districts[this.props.prefix]}
                  settings={this.props.serviceInfo.eservice.mapConfig}
                />
              </GrayPanel>
          }

            <div className="row">
              <div className="col-sm-12">
                {(!this.state.isServiceSelected && !this.state.showWFS) &&
                  <button type="submit" className={cx('btn btn-primary', s.buttonSubmit)} onClick={() => this.runService()}>Uruchom</button>
                }
                {(this.state.isServiceSelected && !this.state.showWFS && this.state.optradio2) &&
                  <button type="submit" className={cx('btn btn-primary', s.buttonSubmit)} onClick={() => {
                    this.setState({ showWFS: true });
                    countAction(this.props.prefix, 4, 2, this.props.serviceInfo.eservice.id);
                  }}>Uruchom</button>
                }
                {this.state.isServiceSelected &&
                  <button type="submit" className={cx('btn btn-primary', s.buttonSubmit)} onClick={() => this.setState({ isServiceSelected: false, showWFS: false })}>Cofnij</button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ServiceWMSWFS.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts
});

export default withStyles(pans)(withStyles(s)(connect(mapState)(ServiceWMSWFS)));



// WEBPACK FOOTER //
// src/routes/eservices/ServiceWMSWFS.js